import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { OptiBayLearningOutcome } from '@/types/optibay';

const sb = supabase as any;

export interface CreateLearningOutcomeParams {
  sessionId: string;
  shopId: string;
  technicianProfileId?: string;
  systemFamilyId?: string;
  symptomText?: string;
  rootCauseCategory?: string;
  confidence?: string;
  evidenceTypes?: string[];
  evidenceCount?: number;
  testPathCount?: number;
  verificationPassRate?: number;
  repairCount?: number;
  totalDurationMinutes?: number;
  outcomeStatus?: string;
  technicianNotes?: string;
  trainingLinked?: boolean;
}

export function useCreateLearningOutcome() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (params: CreateLearningOutcomeParams) => {
      const { data, error } = await sb
        .from('optibay_learning_outcomes')
        .insert({
          session_id: params.sessionId,
          shop_id: params.shopId,
          technician_profile_id: params.technicianProfileId || null,
          system_family_id: params.systemFamilyId || null,
          symptom_text: params.symptomText || null,
          root_cause_category: params.rootCauseCategory || null,
          confidence: params.confidence || 'medium',
          evidence_types: params.evidenceTypes || [],
          evidence_count: params.evidenceCount ?? 0,
          test_path_count: params.testPathCount ?? 0,
          verification_pass_rate: params.verificationPassRate ?? null,
          repair_count: params.repairCount ?? 0,
          total_duration_minutes: params.totalDurationMinutes ?? null,
          outcome_status: params.outcomeStatus || 'successful',
          technician_notes: params.technicianNotes || null,
          training_linked: params.trainingLinked ?? false,
        })
        .select()
        .single();
      if (error) throw error;
      return data as OptiBayLearningOutcome;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['optibay-sessions'] });
    },
  });
}
